import image1 from "../assets/img/service/services-1.jpg";
import image2 from "../assets/img/service/services-2.jpg";
import image3 from "../assets/img/service/services-3.jpg";
import image4 from "../assets/img/service/services-4.jpg";
import image5 from "../assets/img/service/services-5.jpg";
import image6 from "../assets/img/service/services-6.jpg";

const servicesData = [
    {
        id: 'new-builds',
        icon: <i className="flaticon-home"></i>,
        title: 'New Builds',
        description: 'We specialize in creating brand new homes from the ground up, ensuring quality construction, modern design, and energy-efficient solutions tailored to your vision.',
        number: '1',
        image: image1,
    },
    {
        id: 'landscaping',
        icon: <i className="flaticon-project"></i>,
        title: 'Landscaping',
        description: 'Transform your outdoor spaces with our professional landscaping services, including garden design, hardscaping, planting, and maintenance for beautiful outdoor environments.',
        number: '2',
        image: image2,
    },
    {
        id: 'extensions',
        icon: <i className="flaticon-development"></i>,
        title: 'Extensions',
        description: 'Extend your living space with our expert extension services. We handle single and double-storey extensions, ensuring seamless integration with your existing property.',
        number: '3',
        image: image3,
    },
    {
        id: 'bathroom-fittings',
        icon: <i className="flaticon-wrench-1"></i>,
        title: 'Bathroom Fittings',
        description: 'Complete bathroom renovation and fitting services, including installation of fixtures, tiling, plumbing, and modern bathroom design to create your perfect sanctuary.',
        number: '4',
        image: image4,
    },
    {
        id: 'loft-conversions',
        icon: <i className="flaticon-project"></i>,
        title: 'Loft Conversions',
        description: 'Maximize your home\'s potential with our professional loft conversion services, creating additional living space, bedrooms, or home offices with full building regulations compliance.',
        number: '5',
        image: image5,
    },
    {
        id: 'kitchen-fittings',
        icon: <i className="flaticon-wrench"></i>,
        title: 'Kitchen Fittings',
        description: 'Expert kitchen design and installation services, including custom cabinetry, worktops, appliances, and complete kitchen renovations to create your dream cooking space.',
        number: '6',
        image: image6,
    },
    {
        id: 'decorating',
        icon: <i className="flaticon-design-thinking"></i>,
        title: 'Decorating',
        description: 'Professional interior and exterior decorating services, including painting, wallpapering, and finishing touches to refresh and enhance your property\'s appearance.',
        number: '7',
        image: image1,
    },
    {
        id: 'plumbing-works',
        icon: <i className="flaticon-wrench-1"></i>,
        title: 'Plumbing Works',
        description: 'Comprehensive plumbing services including installations, repairs, maintenance, and emergency callouts. Expert plumbers ensure reliable and efficient water systems.',
        number: '8',
        image: image2,
    },
    {
        id: 'refurbishment',
        icon: <i className="flaticon-repairing"></i>,
        title: 'Refurbishment',
        description: 'Complete property refurbishment services, transforming tired spaces into modern, functional, and beautiful environments while maintaining structural integrity.',
        number: '9',
        image: image3,
    },
    {
        id: 'electrical-works',
        icon: <i className="flaticon-technology"></i>,
        title: 'Electrical Works',
        description: 'Professional electrical installation, rewiring, and maintenance services. Certified electricians ensure safe, compliant, and efficient electrical systems for your property.',
        number: '10',
        image: image4,
    },
    {
        id: 'renovation',
        icon: <i className="flaticon-repair"></i>,
        title: 'Renovation',
        description: 'Full property renovation services, revitalizing your home with modern upgrades, structural improvements, and contemporary finishes while preserving its character.',
        number: '11',
        image: image5,
    },
    {
        id: 'interior-design',
        icon: <i className="flaticon-design-thinking"></i>,
        title: 'Interior Design',
        description: 'Transform your spaces with our interior design services, offering innovative concepts, tailored aesthetics, and functional layouts that reflect your unique style and needs.',
        number: '12',
        image: image6,
    },
];

export default servicesData;